module.exports = __webpack_public_path__ + "static/img/notification_title_bg.b1b2520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification_title_bg.png
// module id = 726
// module chunks = 0 1 3 7 9 12 13 16 18 19 20 24 25 26 27 28 29 30 31 32 33 34 35 36 38 39 40 41 42 43 44